import { memo, useEffect } from 'react';
import moment from 'moment';
import { isNil, noop } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
// Import Enums
import { PartnerDateFormat } from 'enums';
// Import Services
import { getCustomerJourneyFormFieldTranslatableErrorText } from 'services/customerJourney/helpers';
// Import Hooks
import { usePartnerDateFormats } from 'hooks/UsePartnerDateFormats';
// Import Components
import ValidatableDatePickerInput from 'components/common/ValidatableDatePickerInput';
// Import Constants
import { dateInitialValueCreator } from './config';

interface Props {
    defaultValue: (string | number)[];
    getUpdate: (value: AnyObject) => void;
    option: AnyObject;
    dateFormat?: Nilable<PartnerDateFormat>;
}

const DateForm: React.FC<Props> = (props) => {
    const { defaultValue, getUpdate, option, dateFormat } = props;
    const { t } = useTranslation();
    const partnerDateFormats = usePartnerDateFormats();
    const format = partnerDateFormats[dateFormat || PartnerDateFormat.DateTimeWithoutSeconds];

    const formik = useFormik({
        initialValues: dateInitialValueCreator(defaultValue, option?.Required),
        onSubmit: noop,
        validationSchema: null, // CJDateTimeOptionValidationSchema(option),
    });
    const { values, setFieldValue, errors } = formik;
    const { date } = values;

    const dateChangeHandler = (e) => {
        const tmpDate = moment(e);
        setFieldValue('date', e);
        getUpdate({ dates: tmpDate.date(), years: tmpDate.year(), months: tmpDate.month() });
    };

    const datePickerBlurHandler = () => {
        if (isNil(date)) {
            dateChangeHandler(dateInitialValueCreator(null, option?.Required).date);
        }
    };

    useEffect(() => {
        const tmpDate = moment(date);
        getUpdate({
            dates: tmpDate.date(),
            years: tmpDate.year(),
            months: tmpDate.month(),
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <ValidatableDatePickerInput
                isTouched={!!errors.date}
                format={format}
                value={date}
                onChange={dateChangeHandler}
                onBlur={datePickerBlurHandler}
                errorText={getCustomerJourneyFormFieldTranslatableErrorText(t, errors?.date)}
            />
        </>
    );
};

export default memo(DateForm);
